// extracted by mini-css-extract-plugin
export default {"wrapper":"SidebarList_wrapper__uEyqq","active":"SidebarList_active__WjmdQ"};